<section class="stats">
  <div class="stat-group">
    <article>{{ advert().streetNameAndHouseNumber }}</article>
    <article>{{ advert().postalCodeAndCity }}</article>
    <article>&nbsp;</article>
  </div>
  <div class="teaser-stats-group">
    <article class="item">
      {{ 'SHARED_COMPONENT.MOVE_OUT' | translate }} {{ advert().moveOutDate | convertDate }}
    </article>
    <article class="item">
      @if (advert().totalRent) {
        <span
          >{{ 'KEY_FACTS.totalRent' | translate }} {{ advert().totalRent | numeral }}
          {{ advert().localization.currency }}</span
          >
        }
        @if (!advert().totalRent) {
          <span>{{ 'KEY_FACTS.totalRent' | translate }} -</span>
        }
      </article>
      <article>&nbsp;</article>
    </div>
    <div class="teaser-contact">
      <article>
        {{ advert().hasNoContactAssigned ? ('SHARED_COMPONENT.NO_CONTACT' | translate) : advert().contactDisplay }}
      </article>
      @if (advert().hasSubstituteContact) {
        <article>
          , {{ advert().substituteContact.firstName }} {{ advert().substituteContact.lastName }}
        </article>
      }
      @if (!advert().hasSubstituteContact) {
        <article>&nbsp;</article>
      }
    </div>
  </section>
